import { RefObject, useLayoutEffect } from 'react';

export default function useAnimationEnd(
    animationRef: RefObject<HTMLElement | null>,
    handler: (name?: string) => void,
    offset = 50,
): void {
    // Recheck after each render: the element's animation can change without its ref changing.
    useLayoutEffect(() => {
        let timeoutId: number | undefined;
        const frameId = requestAnimationFrame(() => {
            const element = animationRef.current;
            if (!element) {
                return;
            }

            const computedStyle = getComputedStyle(element);
            const name = computedStyle.animationName;
            const animationDuration = parseFloat(computedStyle.animationDuration) * 1000;
            const animationDelay = parseFloat(computedStyle.animationDelay) * 1000;

            const totalTime = animationDuration + animationDelay;

            timeoutId = window.setTimeout(() => {
                handler(name);
            }, totalTime - offset);
        });

        return () => {
            cancelAnimationFrame(frameId);
            if (timeoutId !== undefined) {
                window.clearTimeout(timeoutId);
            }
        };
    });
}
